import EarlyRepaymentCalculator from "./EarlyRepaymentCalculator";

export default EarlyRepaymentCalculator;
